export default "__VITE_ASSET__2f1e2aa3__"